import {
    FloorArea,
    ListingAnalyticsTaxonomy,
    ListingData,
    ListingPricing,
    ListingStatusSummary,
    PriceInfo,
    ListingTag,
    Maybe,
    MediaContent,
    EmbeddedContent,
    Features
} from 'graphql.generated';

import { OpenModal } from 'listing-details/components/ModalManager/ModalManager.types';

export type ListingSummaryDetailsProps = {
    data: ListingSummaryDetailsFragment;
    openModal: OpenModal;
};

type Pricing = {
    alternateRentFrequencyPrice: Maybe<
        Pick<PriceInfo, 'internalValue' | 'rentFrequencyLabel'>
    >;
    pricePerFloorAreaUnit: Maybe<
        Pick<PriceInfo, 'internalValue' | 'unitsLabel'>
    >;
} & Pick<
    ListingPricing,
    'rentFrequencyLabel' | 'isAuction' | 'priceQualifierLabel' | 'label'
>;

export type ListingSummaryDetailsFragment = {
    content: Pick<MediaContent, 'floorPlan'>;
    embeddedContent: Pick<EmbeddedContent, 'videos' | 'tours' | 'links'>;
    pricing: Pricing;
    tags: Maybe<Array<Pick<ListingTag, 'label'>>>;
    statusSummary: Maybe<Pick<ListingStatusSummary, 'label'>>;
    analyticsTaxonomy: Pick<ListingAnalyticsTaxonomy, 'section'>;
    floorArea: Maybe<Pick<FloorArea, 'unitsLabel' | 'value'>>;
    features: Maybe<Pick<Features, 'flags'>>;
} & Pick<
    ListingData,
    'administrationFees' | 'counts' | 'displayAddress' | 'title'
>;

export enum SECTIONS {
    TO_RENT = 'to-rent',
    FOR_SALE = 'for-sale'
}

export type ProcessedAttributesReturnType = {
    floorAreaLabel: string | null;
    numBedrooms: string | null;
    numBathrooms: string | null;
    numLivingRooms: string | null;
};
